import { FC } from 'react';
import MoreMenu from '@/components/more-menu';
import CopyMenuItem from '@/components/more-menu/copy-menu-item';

interface Props {
  resourceId: string;
}

const AuditLogMenu: FC<Props> = ({ resourceId }) => {
  const hasResourceId = !!resourceId; // Resource Id can be empty string

  return (
    <MoreMenu menuId="audit-log-menu">
      {hasResourceId && <CopyMenuItem value={resourceId} label="Copy resource ID" icon="copy-id" />}
    </MoreMenu>
  );
};

export default AuditLogMenu;
